import { FormHelperText } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { CountryData, PhoneInputProps } from "react-phone-input-2";
import PhoneInput from "react-phone-input-2";
import styled from "styled-components";

import "react-phone-input-2/lib/plain.css";

const AVAILABLE_COUNTRY_CODES = ["se", "gb", "us"];

interface Props extends PhoneInputProps {
  country: string | number | undefined;
  value: string | null | undefined;
  onChange: (
    value: string,
    data: CountryData,
    event: React.ChangeEvent<HTMLInputElement>,
    formattedValue: string
  ) => void;
  error?: boolean;
  helperText?: string;
}

export const PhoneNumberInput: React.FC<Props> = ({ country, value, onChange, error, helperText, ...props }) => {
  const { t } = useTranslation();

  return (
    <div>
      <StyledPhoneInput
        disableDropdown
        disableCountryGuess
        countryCodeEditable={false}
        country={country}
        onlyCountries={AVAILABLE_COUNTRY_CODES}
        masks={{ se: ".. ... .. .." }}
        inputProps={{
          name: "phone_number",
          required: true,
        }}
        onChange={onChange}
        value={value}
        placeholder={t("form.phone_number")}
        $error={error}
        {...props}
      />
      {helperText && (
        <FormHelperText error={!!error} sx={{ mx: "12px" }}>
          {helperText}
        </FormHelperText>
      )}
    </div>
  );
};

const StyledPhoneInput = styled(PhoneInput)<{ $error?: boolean }>`
  .form-control {
    ${props => props.theme.font.input.field}
    height: 49px;
    width: 100%;
    padding-left: 34px;
    color: ${({ theme }) => theme.colors.redesign.db100} !important;
    border: 1px solid ${({ theme, $error }) => ($error ? theme.colors.tomato : theme.colors.redesign.db20)} !important;
    border-radius: ${props => props.theme.borderRadius.basic};
    font-size: 14px;
    font-weight: 400;

    &:hover {
      border-color: ${({ theme, $error }) => ($error ? theme.colors.tomato : theme.colors.redesign.b100)} !important;
    }

    &:focus {
      border: 2px solid ${({ theme, $error }) => ($error ? theme.colors.tomato : theme.colors.redesign.b100)} !important;
    }

    &::placeholder {
      color: ${props => props.theme.colors.primary.base};
      opacity: 0.4;
    }
  }

  .flag-dropdown {
    border: none;
    pointer-events: none;
  }

  .flag-dropdown.open {
    background: none;

    .selected-flag {
      background: none;
    }
  }

  .selected-flag {
    padding: 0 0 0 12px;
    background: none;

    &:hover {
      background: none;
    }
  }
`;
